// function download(filename, textInput) {

//   var element = document.createElement('a');
//   element.setAttribute('href','data:text/plain;charset=utf-8, ' + encodeURIComponent(textInput));
//   element.setAttribute('download', filename);
//   document.body.appendChild(element);
//   element.click();
//   //document.body.removeChild(element);
// }

const download = (URI: string) => {
  const onBeforeUnload = window.onbeforeunload;
  window.onbeforeunload = null;
  window.location.href = URI;
  setTimeout(() => {
    window.onbeforeunload = onBeforeUnload;
  }, 500);
};

export default download;
